/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A live directory group a member belongs to.
 */
export type AccessMemberDirectoryGroup = {
  /**
   * Directory group identifier.
   */
  id: string;
  /**
   * Directory group name.
   */
  name: string;
};

/** @internal */
export const AccessMemberDirectoryGroup$inboundSchema: z.ZodMiniType<
  AccessMemberDirectoryGroup,
  unknown
> = z.object({
  id: z.string(),
  name: z.string(),
});

export function accessMemberDirectoryGroupFromJSON(
  jsonString: string,
): SafeParseResult<AccessMemberDirectoryGroup, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AccessMemberDirectoryGroup$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AccessMemberDirectoryGroup' from JSON`,
  );
}
